import { AddEntityDialog } from "@/components/common/add-entity-dialog";
import { addProductCategorySchema } from "@/zod-schemas/products/add-product-category-schema";
import { getProductCategoryFormValues } from "@/default-form-values/products/default-product-category-form-values";
import { useCreateProductCategory } from "@/hooks/products/use-product-categories";

export function AddCategoryDialog() {
  const createCategory = useCreateProductCategory();

  return (
    <AddEntityDialog
      entityName="Category"
      schema={addProductCategorySchema}
      defaultValues={getProductCategoryFormValues}
      onCreate={async (data) => {
        await createCategory.mutateAsync({
          name: data.name,
        });
      }}
    />
  );
}
